<template>
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
  >
    <path d="M19.25 0.5C19.6297 0.5 19.9435 0.782154 19.9932 1.14823L20 1.25V14.75C20 15.1642 19.6642 15.5 19.25 15.5C18.8703 15.5 18.5565 15.2178 18.5069 14.8518L18.5 14.75V1.25C18.5 0.835786 18.8358 0.5 19.25 0.5ZM10.2098 2.38702L10.293 2.29282C10.6535 1.93237 11.2207 1.9047 11.613 2.20977L11.7072 2.29297L16.7038 7.29061C17.064 7.65093 17.0919 8.21778 16.7873 8.61006L16.7042 8.70427L11.7076 13.7077C11.3173 14.0985 10.6842 14.0989 10.2934 13.7087C9.93265 13.3484 9.90453 12.7812 10.2093 12.3887L10.2924 12.2945L13.581 9H1C0.487164 9 0.0644929 8.61396 0.00672781 8.11662L0 8C0 7.48716 0.38604 7.06449 0.883379 7.00673L1 7H13.584L10.2928 3.70703C9.93238 3.34651 9.90471 2.77928 10.2098 2.38702L10.293 2.29282L10.2098 2.38702Z" />
  </svg>
</template>
